import { Form, Input, Button } from 'antd';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { useUserActions } from '_actions';
import { Redirect } from 'react-router-dom';
import { authAtom } from '_state';
import { useRecoilValue } from 'recoil';
import { useAuthWrapper } from '_helpers';
export { Login };

function Login(props) {
    const userActions = useUserActions();
    const auth = useRecoilValue(authAtom);
    const authWrapper = useAuthWrapper();
    const [loginDone, setLoginDone] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        async function loadUser() {
            await authWrapper.loadUser();
            setLoginDone(true);
        }
        if (auth)
            loadUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth]);

    const onFinish = async (values) => {
        setSubmitting(true);
        await userActions.login(values);
        setSubmitting(false);
    };

    if (loginDone)
        return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;

    return (
        <div className="account-screen">
            <div className="account-card">
                <div className="account-brand">
                    <Link to="/" className="account-brand-link"><img src="/logos/MASON_logo-ngang-bl.png" alt="The Mason" className="account-logo logo-light" /><img src="/logos/MASON_logo-ngang-w.png" alt="The Mason" className="account-logo logo-dark" /></Link>
                    <div className="account-brand-sub">
                        Đăng nhập để tiếp tục
                    </div>
                </div>
                <Form layout="vertical" onFinish={onFinish} autoComplete="off">
                    <Form.Item
                        label="Tài khoản"
                        name="username"
                        rules={[{ required: true, message: 'Vui lòng điền tên người dùng' }]}
                    >
                        <Input placeholder="Nhập tên đăng nhập" />
                    </Form.Item>
                    <Form.Item
                        label="Mật khẩu"
                        name="password"
                        rules={[{ required: true, message: 'Vui lòng điền mật khẩu' }]}
                    >
                        <Input.Password placeholder="Nhập mật khẩu" />
                    </Form.Item>
                    <Form.Item className="account-form-actions">
                        <Button type="primary" htmlType="submit" loading={submitting} className="account-submit">
                            Đăng nhập
                        </Button>
                    </Form.Item>
                </Form>
                <div className="account-foot-link">
                    <Link to="passwordrecover">Quên mật khẩu?</Link>
                </div>
            </div>
        </div>
    );
}
